import React from 'react'
import { useSearchParams } from 'react-router-dom'

const ProjectIcBanner = ({certificateImage}) => {


  return (
   certificateImage ?  <div className='bg-greenBrand7 w-full h-[31.7rem] flex items-center justify-center mt-4' >
      
     
        
        
        <div className='  w-[44.625rem] rounded-md overflow-hidden h-[27.0625rem] '>
        <img className='h-full w-full object-cover' src={certificateImage} alt="projectic-banner" /> 
        </div>
 
      
    </div> : null)
  
}

export default ProjectIcBanner